import React, { useEffect, useState } from "react";
import styles from "./ChildrenRequirementDetailsContainer.module.css";
import { DateBlock, DetailsContainer } from "./components";
import { CustomButton, icon } from "../..";
import { translate, translateDateTime } from "../../../providers";

const ChildrenRequirementDetailsContainer = ({
	deliverableName,
	parentRequirement = null,
	isEditing = false,
	isPhaseLocked = false,
	onCancelEdit,
	onSaveEdit,
	onUpdateChildrenRequirement,
	updatedChildrenRequirement,
}) => {
	const [localIsEditing, setLocalIsEditing] = useState(isEditing);
	useEffect(() => {
		setLocalIsEditing(isEditing);
	}, [isEditing]);
	const handleInitEdit = () => {
		setLocalIsEditing(true);
	};
	const handleCancelEdit = () => {
		setLocalIsEditing(false);
		if (typeof onCancelEdit === "function") {
			onCancelEdit();
		}
	};
	const handleSaveEdit = () => {
		if (typeof onSaveEdit === "function") {
			onSaveEdit(() => setLocalIsEditing(false));
		}
	};
	return (
		<div className={styles.container}>
			<div className={styles.header}>
				<div className={styles.header__dates} data-has-parent-details={!!parentRequirement}>
					<DateBlock
						date={translateDateTime(updatedChildrenRequirement?.creationDate)}
						title={translate("common:children-requirements.date-creation")}
					/>
					<DateBlock
						date={translateDateTime(updatedChildrenRequirement?.modifiedDate)}
						title={translate("common:children-requirements.date-last-synchronization")}
					/>
				</div>
				{!!parentRequirement && (
					<>
						{(localIsEditing && (
							<span className={styles.header__secondaryActions}>
								<CustomButton color="secondary" variant="outlined" onClick={handleCancelEdit}>
									{translate("common:btn.cancel")}
								</CustomButton>
								<CustomButton
									color="primary"
									startIcon={icon.faSave}
									variant="contained"
									onClick={handleSaveEdit}
								>
									{translate("common:btn.save")}
								</CustomButton>
							</span>
						)) || (
							<span className={styles.header__secondaryActions}>
								<CustomButton
									color="primary"
									disabled={isPhaseLocked}
									startIcon={icon.faPenToSquare}
									variant="contained"
									onClick={handleInitEdit}
								>
									{translate("common:btn.edit")}
								</CustomButton>
							</span>
						)}
					</>
				)}
			</div>
			<div className={styles.container__details}>
				<DetailsContainer
					deliverableName={deliverableName}
					isEditing={localIsEditing}
					parentRequirement={parentRequirement}
					updatedChildrenRequirement={updatedChildrenRequirement}
					onUpdateChildrenRequirement={onUpdateChildrenRequirement}
				/>
			</div>
		</div>
	);
};

export default ChildrenRequirementDetailsContainer;
